<template>
    <div class="container">
        <img src="../assets/img/404.png" alt="" class="img-404 margin-top-xl">
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    computed: {},
    mounted() {
        // 路由使用的是 history ， 所以监听 history
        if (window.history && window.history.pushState) {
            history.pushState(null, null, document.URL)
            window.addEventListener('popstate', this.toBack, false)
        }
    },
    // 离开组件时，取消监听
    destroyed() {
        window.removeEventListener('popstate', this.toBack, false);
    },
    methods: {
        toBack() {
            this.$router.replace({path: '/'})
        }
    },
    components: {},
}
</script>

<style scoped lang="scss">
.container {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #ffffff;
    .img-404 {
        width: 30%;
        min-width: 300px;
    }
}
</style>